import { useRouter } from 'next/compat/router'
import { useDispatch } from 'react-redux'

import { openFacilityFloorsDrawer } from '@/redux/ui/uiSlice'

export const useNavigation = () => {
  const { push } = useRouter()
  const dispatch = useDispatch()

  const goToFloorPlan = (floorId: string) => {
    dispatch(openFacilityFloorsDrawer())
    push({
      pathname: '/floor-plan/',
      query: { floorId: floorId },
    })
  }
  return { goToFloorPlan }
}
